import { GlobalState } from "little-state-machine";

export const updateIsUserFilterDrawerOpen = (state: GlobalState, isUserFilterDrawerOpen: boolean) => ({
  ...state,
  isUserFilterDrawerOpen
});
